// What a person may see and do in a company, as the admin set it on the
// person's card in Team & Roles (audit plan 3.1; one place since 2026-10-19). The database is the authority:
// row security and the server routes check the same capabilities, so the
// screens only follow it -- hiding what would be refused anyway.
import { useEffect, useState } from "react";
import { supabase } from "../supabase";

// The capability list, the page map and the card's rules live in
// ./accessRules (pure, so the live tests run the same code).
export { CAPABILITIES, CONFIGURABLE_ROLES, PAGE_CAPS, pagesAllowedByCaps } from "./accessRules";

const cache = new Map();
export async function loadCapabilities(companyId, { fresh = false } = {}) {
  if (!companyId) return null;
  if (!fresh && cache.has(companyId)) return cache.get(companyId);
  const { data, error } = await supabase.rpc("my_capabilities", { p_company_id: companyId });
  if (error || !data) return null;
  cache.set(companyId, data);
  return data;
}
export function clearCapabilityCache() { cache.clear(); }

/** caps object (or null while loading) for the signed-in person in this company. */
export function useCapabilities(companyId) {
  const [caps, setCaps] = useState(() => (companyId && cache.get(companyId)) || null);
  useEffect(() => {
    let live = true;
    loadCapabilities(companyId).then(c => { if (live) setCaps(c); });
    return () => { live = false; };
  }, [companyId]);
  return caps;
}

/** True unless the capability is known to be withheld (so nothing flickers away for admins). */
export const can = (caps, cap) => !caps || caps[cap] !== false;
